<div
   class="scroll-container"
   [class.side-bar]="sideBarContainer"
   #bodyElement>
   <ng-container *ngTemplateOutlet="bodyTemplate?.templateRef"></ng-container>
</div>
